import { uploadToCloudinary } from "../../../../../utils/cloudinary";

/**
 * Upload post image to Cloudinary
 * @param {File} file - Image file
 * @param {string} userId - User ID
 * @returns {Promise<string>} - Image URL
 */
export const uploadPostImage = async (file, userId) => {
  if (!file) throw new Error("No file provided");
  if (!userId) throw new Error("No user ID provided");
  const folder = "user_photos/posts";
  return await uploadToCloudinary(file, { folder, compress: true });
};
